/* global Intercom */

class IntercomAdapter {
  /**
   * Track internal users on Intercom
   * @param {String} title - Description of the event
   * @param {Object} event - Data to track
   * @see https://developers.intercom.com/installing-intercom/docs/intercom-javascript
   */
  static track(title, event) {
    if (typeof Intercom !== 'undefined') {
      Intercom('trackEvent', title, event);
    }
  }

  /**
   * Intercom Identify
   * @see https://developers.intercom.com/installing-intercom/docs/javascript-api-attributes-objects
   */
  static identify(userProperties, companyProperties) {
    if (typeof Intercom !== 'undefined') {
      Intercom('update', {
        ...userProperties,
        company: companyProperties,
      });
    }
  }
}

export default IntercomAdapter;
